import * as Scrivito from 'scrivito';
import { TableRowWidgetClass } from './table-row-widget-class';

export const TableRowWidgetComponent: React.FC = () => {
  return <Scrivito.WidgetTag />;
};

Scrivito.provideComponent(TableRowWidgetClass, TableRowWidgetComponent);
